import { Modal } from 'react-disposable-modal'
export default Modal